module.exports = __webpack_public_path__ + "static/e88d3836-d826-40bc-be49-c6de5dfd8c28-160.c56ed385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/hyde-park-chapel-london/e88d3836-d826-40bc-be49-c6de5dfd8c28-160.jpg
// module id = 982
// module chunks = 168707334958949